export enum AvvState {
  UNDEFINED = 'UNDEFINED',
  AVV_USAGE = 'AVV_USAGE',
  PRIVATE = 'PRIVATE',
  NO_THIRD_PARTY_DATA_USAGE = 'NO_THIRD_PARTY_DATA_USAGE',
  AVV_ALREADY_PRESENT = 'AVV_ALREADY_PRESENT',
  AVV_REVOKED = 'AVV_REVOKED',
}
